export const LISTVIEW_LOCALE_ZHCHS = {
    emptyMessage: 'ææ æ°æ®',
    checkAll: 'å¨é'
};
